import { parsePostClaimScenarios } from '../util/postClaimCta';

export const POST_CLAIM_CTA_CONFIG = parsePostClaimScenarios(process.env.REACT_APP_POST_CLAIM_SCENARIOS);
